import { Component, Input, OnInit, TemplateRef, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { WebsiteIdentity, WebsiteModel } from '../../portal.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/lsg.api.service';
import { ToastrService } from 'ngx-toastr';
import { Store } from '@ngrx/store';
import { isWebsiteLoaded, selectWebsite, selectWebsiteIdentity } from 'src/app/shared/store/_features/website/website.selector';
import { SharedPortalViewService } from '../shared-portal-view.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subscription, Observable } from 'rxjs';
import { FormSectionController, FromSectionContext, FormSectionModel } from 'src/app/models/multiple-sections-form';
import { InOutAnimation } from 'src/app/shared/animations/animations';

@Component({
    selector: 'app-site-identity',
    templateUrl: './site-identity.component.html',
    styleUrls: ['./site-identity.component.css'],
    animations: [InOutAnimation]
})
export class SiteIdentityComponent implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild('IdentitySection') IdentitySectionTemplate!: TemplateRef<any>;

    websiteLoaded$: Observable<boolean>;
    website$: Observable<WebsiteModel>;

    portalIdentityConfigurationForm = new FormGroup({
        label: new FormControl<string>(null, {
            updateOn: 'change',
            validators: [Validators.required],
        }),
        title: new FormControl<string>(null, {
            updateOn: 'change',
            validators: [Validators.required],
        }),
        description: new FormControl<string>(null, {
            updateOn: 'change',
            validators: [Validators.required],
        }),
    });

    formSections: FormSectionController = new FormSectionController([
        {
            title: 'Site Information',
            template: null,
            templateName: 'IdentitySectionTemplate',
            context: {
                actionsSection: {
                    isSaveEnable: false,
                    showAlways: false,
                    isStick: false,
                },
                title: 'Site Information',
                description: 'Search engine and browser tab appearance.',
                controls: ['title', 'description', 'label'],
            },
        },
    ]);

    identity: WebsiteIdentity;

    subscriptions: Subscription[] = []

    confirmationRequired = false;
    iConfirm = false;

    loaded = false;
    saving = false;

    constructor(
        public sharedPortalViewService: SharedPortalViewService,
        private modalService: NgbModal,
        private route: Router,
        private api: ApiService,
        private toastr: ToastrService,
        private store: Store
    ) {
        this.websiteLoaded$ = this.store.select(isWebsiteLoaded);
        this.website$ = this.store.select(selectWebsite);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    ngAfterViewInit(): void {
        this.formSections.sections.forEach((section) => {
            section.template = this[section.templateName];
        });
    }

    async ngOnInit() {
        this.subscriptions.push(
            this.store.select(selectWebsiteIdentity).subscribe(identity => {
                if (identity) {
                    this.identity = identity;
                    this.portalIdentityConfigurationForm.patchValue(identity, { emitEvent: false });
                }
            })
        );

        this.trackFormChanges();
    }

    resetSection(context: FromSectionContext) {
        Object.keys(this.portalIdentityConfigurationForm.controls).forEach((controlName) => {
            if (context?.controls?.includes(controlName)) {
                this.portalIdentityConfigurationForm
                    .get(controlName)
                    ?.setValue(this.identity[controlName], {
                        emitEvent: false,
                    });
                context.actionsSection.isSaveEnable = false;
            }
        });
    }

    trackFormChanges() {
        Object.keys(this.portalIdentityConfigurationForm.controls).forEach((controlName) => {
            this.subscriptions.push(
                this.portalIdentityConfigurationForm
                    .get(controlName)
                    ?.valueChanges.subscribe((value) => {
                        this.formSections.sections.forEach((section) => {
                            if (section.context?.controls?.includes(controlName)) {
                                section.context.actionsSection.isSaveEnable = true;
                            }
                        });
                    })
            );
        });
    }

    async onSave(context?: FromSectionContext) {
        this.sharedPortalViewService.processing = 'loading';
        this.saving = true;
        try {
            const formValue = this.portalIdentityConfigurationForm.value;

            let payload = {
                title: formValue.title,
                description: formValue.description,
                label: formValue.label,
            };

            await this.sharedPortalViewService.setWebsiteIdentity(payload as any);

            // Update identity reference to avoid reset reverting to old values
            this.identity = { ...this.identity, ...payload } as any;

            if (context) {
                context.actionsSection.isSaveEnable = false;
            } else {
                this.formSections.sections.forEach(s => s.context.actionsSection.isSaveEnable = false);
            }

            this.toastr.success('Settings updated successfully');
        } catch (error) {
            this.toastr.error('Failed to update settings');
        } finally {
            this.sharedPortalViewService.processing = 'done';
            this.saving = false;
        }
    }

}
